import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useParams } from "react-router-dom";
const Thankyou = () => {
  const { id } = useParams();
  return (
    <>
    <Header/>
      <section className="fh-thankyou-section">
  <div className="fh-thankyou-card">
    <div className="fh-thankyou-icon">✓</div>
    <h1 className="fh-thankyou-title">Thank You!</h1>
     <h2> Booking 🎉 Confirmed! </h2>
      <h3>Your Booking ID: #{id}</h3>
    <p className="fh-thankyou-msg">
      Your order has been successfully placed. We appreciate your trust and will
      notify you when it's ready.
    </p>
    <a href="/" className="fh-thankyou-btn">
      Go Back to Home
    </a>
  </div>
</section>
<Footer/>
    </>
  );
};

export default Thankyou;
